import { ReportService } from './../../../shared/services/report/report.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-admin-reports',
  templateUrl: './admin-reports.component.html',
  styleUrls: ['./admin-reports.component.scss']
})
export class AdminReportsComponent implements OnInit {
  clubCode: any;
  title: string;
  searchForm: UntypedFormGroup;

  menu: any[] = [
    // {
    //   name: 'Les stagiaires',
    //   description: 'Exporter les stagiaires en fichier excel',
    //   icon: 'faArrowAltCircleUp',
    //   iconLabel: 'faArrowAltCircleUp',
    //   iconType: 'faicon',
    //   role: ['admin'],
    //   keyWord: "trainee"
    // },
    // {
    //   name: 'Les réservations',
    //   description: 'Exporter les réservations en fichier excel',
    //   icon: 'faArrowAltCircleUp',
    //   iconLabel: 'faArrowAltCircleUp',
    //   iconType: 'faicon',
    //   role: ['admin'],
    //   keyWord: "booking"
    // },
    // {
    //   name: 'Les sessions',
    //   description: 'Exporter les sessions en fichier excel',
    //   icon: 'faArrowAltCircleUp',
    //   iconLabel: 'faArrowAltCircleUp',
    //   iconType: 'faicon',
    //   role: ['admin'],
    //   keyWord: "session"
    // },
    // {
    //   name: 'Les paiements',
    //   description: 'Exporter les paiements en fichier excel',
    //   icon: 'faArrowAltCircleUp',
    //   iconLabel: 'faArrowAltCircleUp',
    //   iconType: 'faicon',
    //   role: ['admin'],
    //   keyWord: "payment"
    // },
    {
      name: 'Totalité des données',
      description: 'Exporter l\'ensemble des données en excel',
      icon: 'faArrowAltCircleUp',
      iconLabel: 'faArrowAltCircleUp',
      iconType: 'faicon',
      role: ['admin'],
      keyWord: "DbExtract"
    },
    // {
    //   name: 'Clubs, offres et paiements',
    //   description: 'Exporter l\'ensemble des données des clubs, offres et paiements en excel',
    //   icon: 'faArrowAltCircleUp',
    //   iconLabel: 'faArrowAltCircleUp',
    //   iconType: 'faicon',
    //   role: ['admin'],
    //   keyWord: "clubOfferPayment"
    // }
  ]

  constructor(
    protected uiSrv: UiService,
    private formBuilder: UntypedFormBuilder,
    private faIconService: FaiconService,
    private tooltipSrv: TooltipService,
    private reportSrv: ReportService
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private async initComponent() {

    this.title = 'Extractions de tables';

    this.initForm();
    // this.initSubscriptions();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  exportExcel(keyWord: string) {
    this.reportSrv.getReport(keyWord).subscribe();
  }
}
